module.exports = "https://cdn.hellotech.com/client-assets/garage_doors_desktop_ff01bfe2d89db0b44ec80e4e316cc316.png";